import React, { ReactNode, useEffect, useRef, useState } from "react";
import "./auto-sizer.scss";

interface AutoSizerProps {
	children: (size: { height: number; width: number }) => ReactNode;
	className?: string;
}

export const AutoSizer: React.FC<AutoSizerProps> = ({
	children,
	className,
}) => {
	const ref = useRef<HTMLDivElement | null>(null);
	const [size, setSize] = useState({ height: 300, width: 300 });

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		const update = () => {
			setSize({ height: el.clientHeight || 300, width: el.clientWidth || 300 });
		};

		update();

		let ro: ResizeObserver | null = null;
		if (typeof (window as any).ResizeObserver !== "undefined") {
			ro = new (window as any).ResizeObserver(() => update());
			if (ro && el) ro.observe(el);
		} else {
			window.addEventListener("resize", update);
		}

		return () => {
			if (ro) ro.disconnect();
			else window.removeEventListener("resize", update);
		};
	}, []);

	return (
		<div ref={ref} className={className ?? "auto-sizer__container"}>
			{children(size)}
		</div>
	);
};

export default AutoSizer;
